import { create } from 'zustand';
import { persist } from 'zustand/middleware';

import { createEmptyFeedbackFlow } from '../utils/feedbackFlow';

import type { FeedbackFlow } from '../types/experiment.types';

interface ExperimentStore {
  previewFeedbackFlow: FeedbackFlow;
  setPreviewFeedbackFlow: (feedbackFlow: FeedbackFlow) => void;
  clearPreviewFeedbackFlow: () => void;
}

export const useExperimentStore = create<ExperimentStore>()(
  persist(
    (set) => ({
      previewFeedbackFlow: createEmptyFeedbackFlow(),
      setPreviewFeedbackFlow: (previewFeedbackFlow) => set({ previewFeedbackFlow }),
      clearPreviewFeedbackFlow: () =>
        set({ previewFeedbackFlow: createEmptyFeedbackFlow() }),
    }),
    {
      name: 'experiment-preview-feedback-flow',
    },
  ),
);
